import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { UserAuthContext } from '../context/AuthContext';
import MessagesError from './MessagesError';
import { useTranslation } from 'react-i18next';
import MeritsInput from '../shared/MeritsInput';
import { Button } from '@material-tailwind/react';

const Signup = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [, setLoading] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { createUser } = UserAuthContext();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setError('');
      setLoading(true);
      await createUser(email, password);
      navigate('/account');
    } catch (e) {
      setError(e.code);
      console.log(e.message, error);
    }
  };

  return (
    <div className="relative flex flex-col justify-center min-h-screen overflow-hidden">
      {error && <MessagesError error={error} setError={setError} />}
      <div className="w-full px-6 m-auto rounded-md shadow-md lg:max-w-xl bg-gradient-to-bl from-blue-300 py-6">
        <p className="text-xs font-light text-left text-gray-70">
          {t('signUp.haveAccount')}{' '}
          <Link className="underline" to="/signin">
            {t('signUp.signIn')}
          </Link>
        </p>
        <h3 className="text-xl font-semibold text-center text-blue-900 pt-8">
          {/* Sign up for a free account */}
          {t('signUp.signUp')}
        </h3>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4 mt-6">
          <MeritsInput
            label={t('email')}
            required={true}
            type="email"
            placeholder={t('password')}
            value={email}
            onChange={({ target }) => setEmail(target.value)}
          />
          <MeritsInput
            label={t('password')}
            required={true}
            type="password"
            placeholder={t('password')}
            value={password}
            onChange={({ target }) => setPassword(target.value)}
          />
          <Button
            disabled={!email || !password}
            className="w-full transform bg-blue-900 rounded-md hover:bg-blue-600focus:bg-blue-600"
            onClick={handleSubmit}
          >
            {t('signUp.signUp')}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default Signup;
